import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage-angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { JwtModule, JWT_OPTIONS, JwtInterceptor } from '@auth0/angular-jwt';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { PromotionModalPage } from './promotions/promotion-modal/promotion-modal.page';
import { RefreshTokenInterceptor } from './auth/auth-refresh.interceptor';
import { GeneralModule } from './general/general.module';
import { Camera } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { GooglePlus } from '@ionic-native/google-plus/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { SettingsPopoverComponent } from './profile/settings-popover/settings-popover.component';
import { PromotionExchangedModalPage } from './promotions/promotion-exchanged-modal/promotion-exchanged-modal.page';
import { SignInWithApple } from '@ionic-native/sign-in-with-apple/ngx';
import { QRCodeComponent } from 'angularx-qrcode';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { Stripe } from '@ionic-native/stripe/ngx';
import { environment } from '../environments/environment';
import { TranslocoRootModule } from './transloco-root.module';
import { StorageService } from './storage.service';

import { APP_INITIALIZER } from '@angular/core';
import { ProfileService } from './profile/profile.service';

export function jwtOptionsFactory(storageService: StorageService) {
  return {
    tokenGetter: async () => {
      await storageService.init();
      return await storageService.get('jwt-token');
    },
    allowedDomains: [environment.url.split('//')[1]] 
  };
}

export function initProfile(profileService: ProfileService, storageService: StorageService) {
  return async () => {
    await storageService.init();
    const token = await storageService.get('jwt-token');

    if (token) {
      try {
        await profileService.loadProfile();
      } catch (err) {
        console.warn('No se pudo cargar el perfil:', err);
      }
    } else {
      console.log('Sin token: no se carga el perfil');
    }
  };
}

@NgModule({
  declarations: [
    AppComponent,
    PromotionModalPage,
    SettingsPopoverComponent,
    PromotionExchangedModalPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      mode: 'md'
    }),
    AppRoutingModule,
    HttpClientModule,   
    IonicStorageModule.forRoot(),
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [StorageService]
      }
    }),
    FormsModule,
    QRCodeComponent,
    GeneralModule,
    ReactiveFormsModule,
    TranslocoRootModule,
  ],
  providers: [
    JwtInterceptor,
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: JwtInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true
    },
    {
    provide: APP_INITIALIZER,
    useFactory: initProfile,
    deps: [ProfileService, StorageService],
    multi: true
    },
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    Geolocation,
    Camera,
    File,
    GooglePlus,
    SignInWithApple,
    SocialSharing,
    Stripe,
    InAppBrowser,
    AppVersion,
    AndroidPermissions,
    StorageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  
}
